import { useState, useEffect } from 'react';
import { searchGraphUsers, GraphUser } from '../../../utils/MsGraphApiCall';

/**
 * useUserSearch – Encapsulates the debounced MS Graph user-search pattern.
 * Eliminates duplication between ApprovalStepConfig and AutoAssignmentConfig.
 */
export const useUserSearch = (debounceMs = 300) => {
  const [results, setResults] = useState<GraphUser[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (query.length < 2) {
      setResults([]);
      return;
    }

    const timeoutId = setTimeout(async () => {
      setIsLoading(true);
      try {
        const users = await searchGraphUsers(query);
        setResults(users);
      } catch {
        setResults([]);
      } finally {
        setIsLoading(false);
      }
    }, debounceMs);

    return () => clearTimeout(timeoutId);
  }, [query, debounceMs]);

  const reset = () => {
    setQuery('');
    setResults([]);
  };

  return { results, isLoading, query, setQuery, reset };
};
